import React,{useEffect} from "react";
import Helmet from "react-helmet";
import Header from "./header"
import Footer from "./footer"
import {Link} from "react-router-dom"
import {useSelector,useDispatch} from "react-redux"
import {getHorescope} from '../state/action'
function Horscope(){
  const  horscope  = useSelector((state) =>state.gemstone.horscope);
 
const dispatch = useDispatch();
console.log(horscope)
useEffect(() => {
  dispatch(getHorescope());
}, []);
    return (
        <div>
        <Header/>
       <section className="page-title centred" style={{backgroundImage: 'url(https://images.unsplash.com/photo-1623228898202-de83b59829ae?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80)'}}>
  <div className="auto-container">
    <div className="content-box">
      <div className="title">
        <h1>Horscope</h1>
      </div>
      <ul className="bread-crumb clearfix">
        <li><Link to="/">Home</Link></li>
        
      </ul>
    </div>
  </div>
</section>
<section className="service-section sec-pad bg-color-1">
  <div className="auto-container">
    <div className="row clearfix">
      {horscope.map((i)=>{
        return(
          <div className="col-lg-4 col-md-6 col-sm-12 service-block">
          <div className="service-block-one wow fadeInUp animated animated" data-wow-delay="00ms" data-wow-duration="1500ms">
            <div className="inner-box">
              <figure className="image-box">
                <img src={i.image} alt style={{width:"400px",height:"250px"}}/>
                <span className="category">{i.name}</span>
                <i className="flaticon-consulting" />
              </figure>
              <div className="lower-content">
                <p style={{fontSize:"10 px", alignText:"center"}}><span style={{fontSize:"15 px",color:"black"}}>Month</span> - {i.month}</p>
                <p style={{fontSize:"10 px", alignText:"center" }}><span style={{fontSize:"15 px",color:"black"}}>Gemstone</span> - {i.type}</p>
                <p style={{fontSize:"10 px", alignText:"center"}}><span style={{fontSize:"15 px",color:"black"}}>Use</span> - {i.use}</p>
                <p style={{fontSize:"10 px", alignText:"center"}}><span style={{fontSize:"15 px",color:"black"}}>Believe</span> - {i.believe}</p>
               
                <div className="light-icon"><i className="flaticon-consulting" /></div>
              </div>
            </div>
          </div><br></br>
        </div>
        )
      })}
      
     </div>
  </div>
</section>

         <Footer/>
        </div>
    )
}
export default Horscope;